(() => {
  const root = typeof window !== 'undefined' ? window : globalThis;
  const yotpo = root.JFTYotpo || {};

  function registerTestimonialsGallery() {
    if (!root.document || !root.Alpine || !yotpo.buildGalleryTiles || !yotpo.fetchAllReviews) {
      return;
    }

    root.Alpine.data('testimonialsGallery', (config = {}) => ({
      appKey: config.appKey || '',
      sourceId: config.sourceId || '',
      useYotpo: config.useYotpo !== false,
      tileLimit: Number(config.tileLimit) || 10,
      maxPages: Number(config.maxPages) || 10,
      fallbackTiles: Array.isArray(config.fallbackTiles) ? config.fallbackTiles : [],
      tiles: [],
      loading: false,
      loadError: false,

      init() {
        this.loadSourceData();
        this.tiles = this.fallbackTiles.slice(0, this.tileLimit);

        if (!this.useYotpo || !this.appKey) {
          return;
        }

        this.tiles = [];
        this.loading = true;
        this.fetchReviewMedia();
      },

      loadSourceData() {
        if (!this.sourceId || !root.document) {
          return;
        }

        const source = root.document.getElementById(this.sourceId);
        if (!source) {
          return;
        }

        try {
          const data = JSON.parse(source.textContent || '{}');
          this.appKey = data.appKey || this.appKey;
          this.useYotpo = data.useYotpo !== false;
          this.tileLimit = Number(data.tileLimit) || this.tileLimit;
          this.maxPages = Number(data.maxPages) || this.maxPages;
          this.fallbackTiles = Array.isArray(data.fallbackTiles)
            ? data.fallbackTiles
            : this.fallbackTiles;
          this.tiles = this.fallbackTiles.slice(0, this.tileLimit);
        } catch (error) {
          // Keep defaults when config JSON is unavailable.
        }
      },

      async fetchReviewMedia() {
        if (!this.appKey) {
          this.loadError = true;
          return;
        }

        this.loading = true;

        try {
          const { reviews } = await yotpo.fetchAllReviews(this.appKey, { maxPages: this.maxPages });
          const galleryTiles = yotpo.buildGalleryTiles(reviews, this.tileLimit, this.fallbackTiles);
          const hasYotpoMedia = galleryTiles.some((tile) => tile.videoUrl || tile.imageUrl);

          if (hasYotpoMedia) {
            this.tiles = galleryTiles;
          } else {
            this.tiles = this.fallbackTiles.slice(0, this.tileLimit);
          }
        } catch (error) {
          this.loadError = true;
          this.tiles = this.fallbackTiles.slice(0, this.tileLimit);
        } finally {
          this.loading = false;
        }
      },
    }));
  }

  if (root.Alpine) {
    registerTestimonialsGallery();
  } else {
    root.document?.addEventListener('alpine:init', registerTestimonialsGallery);
  }
})();
